import { errorTostHandler } from "helper/ErrorTostHandler";
import {
  ADD_STRIP_CUSTOMER_CARD,
  EDIT_STRIP_CUSTOMER_CARD,
  USER_CARD_DETAILS,
} from "helper/url_helper";
import { axiosAccount } from "services/api";
import {
  ADD_CARD_LOADING,
  FETCH_PAYMENT_DATA,
  FETCH_PAYMENT_DATA_ERROR,
  FETCH_PAYMENT_DATA_LOADING,
} from "./actionTypes";

export const handleFetchPaymentData = payload => {
  return async dispatch => {
    try {
      dispatch(fetchPaymentDataLoading(true));
      const res = await axiosAccount.get(USER_CARD_DETAILS, payload);
      if (res?.data?.data) {
        dispatch(fetchPaymentData(res?.data?.data?.userCardDetail));
        dispatch(fetchPaymentDataLoading(false));
      }
    } catch (err) {
      dispatch(fetchPaymentDataLoading(false));
      dispatch({ type: FETCH_PAYMENT_DATA_ERROR, payload: null });
      errorTostHandler(err, 66);
    }
  };
};

export const handleAddStripCustomerCard = (payload, cb) => {
  return async dispatch => {
    try {
      dispatch(addCardLoading(true));
      const res = await axiosAccount.post(ADD_STRIP_CUSTOMER_CARD, payload);
      if (res?.data?.data?.subscription_data) {
        dispatch(addCardLoading(false));
        cb(res?.data?.data?.subscription_data);
      }
    } catch (err) {
      dispatch(addCardLoading(false));
      errorTostHandler(err, 67);
    }
  };
};

export const handleEditStripCustomerCard = (payload, cb) => {
  return async dispatch => {
    try {
      dispatch(addCardLoading(true));
      const res = await axiosAccount.post(EDIT_STRIP_CUSTOMER_CARD, payload);
      if (res?.data?.data) {
        dispatch(addCardLoading(false));
        cb(res?.data?.data);
      }
    } catch (err) {
      dispatch(addCardLoading(false));
      errorTostHandler(err, 68);
    }
  };
};

export const fetchPaymentDataLoading = data => ({
  type: FETCH_PAYMENT_DATA_LOADING,
  payload: data,
});

export const fetchPaymentData = data => ({
  type: FETCH_PAYMENT_DATA,
  payload: data,
});

export const addCardLoading = data => ({
  type: ADD_CARD_LOADING,
  payload: data,
});
